import React from 'react';
import { useDispatch } from 'react-redux';
import { openCustomModal } from '../../../actions/modal';
import { SimpleButton } from '../../../common/Buttons/SimpleButton';
import IconToolTip from '../../../common/IconToolTip';
import Assign from '../Modal/Assign';
import { PartnerDetailsPopUp } from '../TodayStatus/PartnerDetailsPopUp';
import { useSelector } from 'react-redux';
import { ScogoID } from '../../../utils/common';
import { eligibleForAssign, MilestoneSubStatus } from '../TicketController';
import Menus from '../../../common/Menus';
import { Menu as MUIMenu, MenuItem as MUIMenuItem } from '@mui/material';

export const showInsuredIcon = ({ assignToScogo, ticket_owned_by, symbo_policy_no }) => {
    return (assignToScogo === 1 || ticket_owned_by === 0) && symbo_policy_no !== null;
};

export const PartnerDetail = ({ ticket }) => {
    const showAssignButton = eligibleForAssign(ticket);
    const showRatingButton = false;
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const onRatingClick = () => { };

    const milestoneAgents = React.useMemo(() => {
        const milestoneData = [];
        if (ticket.milestones && Array.isArray(ticket.milestones)) {
            ticket.milestones.forEach((milestone) => {
                const sp = ticket.agents && Array.isArray(ticket.agents) && ticket.agents.find((agent) =>
                    agent.role === 'SP' && agent.milestone_id === milestone.id
                );
                const fe = ticket.agents && Array.isArray(ticket.agents) && ticket.agents.find((agent) =>
                    agent.role === 'FE' && agent.milestone_id === milestone.id
                );

                if (sp || fe) {
                    milestoneData.push({
                        milestone,
                        sp,
                        fe
                    });
                }
            });
        }

        const groupedMilestones = [];
        const processedGroups = new Set();

        milestoneData.forEach((item) => {
            const spId = item.sp?.agent?.id || 'no-sp';
            const feId = item.fe?.agent?.id || 'no-fe';
            const groupKey = `${spId}-${feId}`;

            if (!processedGroups.has(groupKey)) {
                const sameGroup = milestoneData.filter((otherItem) => {
                    const otherSpId = otherItem.sp?.agent?.id || 'no-sp';
                    const otherFeId = otherItem.fe?.agent?.id || 'no-fe';
                    return otherSpId === spId && otherFeId === feId;
                });

                if (sameGroup.length > 1) {
                    groupedMilestones.push({
                        type: 'grouped',
                        milestones: sameGroup,
                        sp: item.sp,
                        fe: item.fe,
                        groupKey
                    });
                    processedGroups.add(groupKey);
                } else {
                    groupedMilestones.push({
                        type: 'single',
                        milestone: item.milestone,
                        sp: item.sp,
                        fe: item.fe
                    });
                }
            }
        });

        return groupedMilestones;
    }, [ticket.milestones, ticket.agents]);

    const getPartnerLabel = (ticket) => {
        const isScogoId = newLoggedUserData.orgMemberships.map(({ id }) => id).includes(ScogoID);

        if (milestoneAgents.length === 0) {
            const sp = ticket.agents && Array.isArray(ticket.agents) && ticket.agents.find((agent) => {
                return agent.role === 'SP';
            });

            const fe = ticket.agents && Array.isArray(ticket.agents) && ticket.agents.find((agent) => {
                return agent.role === 'FE';
            });

            if (sp && fe && sp.agent.id === newLoggedUserData.user.id && fe.agent.id === newLoggedUserData.user.id) {
                return <AssignToYou label='SP/FE' />;
            } else if (sp && fe && sp.agent.id === fe.agent.id) {
                return (
                    <div>
                        <span className='text-scogogray  text-font11 flex items-center w-full'>
                            SP/FE :{' '}
                            {showInsuredIcon(ticket) && (
                                <IconToolTip title='FE is insured for this ticket'>
                                    <span className='material-icons text-scogo2e text-font18'>gpp_good</span>
                                </IconToolTip>
                            )}{' '}
                        </span>
                        <PartnerDetailsPopUp userId={sp.agent.id} displayName={`${sp.agent.display_name}`} onHovertitle={`SP :  ${sp.agent.display_name}`} />
                    </div>
                );
            } else if (sp && fe && sp.agent.id === newLoggedUserData.user.id && fe.agent.id !== newLoggedUserData.user.id) {
                return (
                    <>
                        <AssignToYou label='SP' />
                        <div>
                            <span className='text-scogogray w-10 text-font11'>FE :</span>
                            <PartnerDetailsPopUp
                                userId={fe.agent.id}
                                displayName={`${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                                onHovertitle={`FE :  ${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                            />
                        </div>
                    </>
                );
            } else if (sp && fe) {
                return (
                    <>
                        <div>
                            <span className='text-scogogray w-10 text-font11'>SP :</span>
                            <PartnerDetailsPopUp
                                label='SP :'
                                userId={sp.agent.id}
                                displayName={`${sp.agent.display_name}`}
                                onHovertitle={`SP :  ${sp.agent.display_name}`}
                            />
                        </div>
                        <div>
                            <span className='text-scogogray  text-font11 flex items-center w-full'>
                                FE :{' '}
                                {showInsuredIcon(ticket) && (
                                    <IconToolTip title={'FE is insured for this ticket'}>
                                        <span className='material-icons text-scogo2e text-font16'>gpp_good</span>
                                    </IconToolTip>
                                )}{' '}
                            </span>
                            <PartnerDetailsPopUp
                                userId={fe.agent.id}
                                displayName={`${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                                onHovertitle={`FE :  ${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                            />
                        </div>
                    </>
                );
            } else if (!isScogoId && ticket.helpdesk_id === ScogoID) {
                return <AssignToScogo />;
            }
            return <></>;
        }

        const visibleMilestones = milestoneAgents.slice(0, 1);
        const remainingMilestones = milestoneAgents.slice(1);

        return (
            <>
                {visibleMilestones.map((item, index) => (
                    item.type === 'grouped' ? (
                        <GroupedMilestoneDisplay
                            key={item.groupKey}
                            groupedItem={item}
                            ticket={ticket}
                            newLoggedUserData={newLoggedUserData}
                            isScogoId={isScogoId}
                        />
                    ) : (
                        <MilestonePartnerDisplay
                            key={item.milestone.id}
                            milestone={item.milestone}
                            sp={item.sp}
                            fe={item.fe}
                            ticket={ticket}
                            newLoggedUserData={newLoggedUserData}
                            isScogoId={isScogoId}
                        />
                    )
                ))}

                {remainingMilestones.length > 0 && (
                    <ViewAllMilestones
                        milestones={remainingMilestones}
                        ticket={ticket}
                        newLoggedUserData={newLoggedUserData}
                        isScogoId={isScogoId}
                    />
                )}
            </>
        );
    };

    return (
        <div className='w-full '>
            {getPartnerLabel(ticket)}
            {showAssignButton && <AssignButton ticket={ticket} />}
            {showRatingButton && <IconToolTip title={'Rate your Engineer'}>
                <span>
                    <SimpleButton
                        buttonIconComponent={<span className='material-icons text-font16 '>star_rate</span>}
                        btnClass='hover:bg-scogoorange flex items-center justify-center w-25 h-7 hover:text-white cursor-pointer text-scogoorange border-1 font-medium  border-scogoorange rounded-lg p-1 text-font11'
                        textOrComponent={'Engineer'}
                        onClick={onRatingClick}
                    />
                </span>
            </IconToolTip>}
        </div>
    );
};

const MilestonePartnerDisplay = ({ milestone, sp, fe, ticket, newLoggedUserData, isScogoId }) => {
    const milestoneTitle = milestone.type || milestone.title;

    const Label = ({ icon, text }) => (
        <span className='text-scogogray text-font11 inline-flex items-center gap-1 whitespace-nowrap'>
            <span className='material-icons text-font12'>{icon}</span>
            <span className='whitespace-nowrap'>{text}</span>
        </span>
    );

    const SpRow = () => (
        <div className='flex items-center gap-2'>
            <Label icon='manage_accounts' text='SP :' />
            {sp ? (
                <PartnerDetailsPopUp
                    userId={sp.agent.id}
                    displayName={`${sp.agent.display_name}`}
                    onHovertitle={`SP :  ${sp.agent.display_name}`}
                />
            ) : (
                <span className='text-scogogray text-font11'>—</span>
            )}
        </div>
    );

    const FeRow = () => (
        <div className='flex items-center gap-2'>
            <Label icon='engineering' text='FE :' />
            {showInsuredIcon(ticket) && (
                <IconToolTip title={'FE is insured for this ticket'}>
                    <span className='material-icons text-scogo2e text-font14 leading-none'>gpp_good</span>
                </IconToolTip>
            )}
            {fe ? (
                <PartnerDetailsPopUp
                    userId={fe.agent.id}
                    displayName={`${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                    onHovertitle={`FE :  ${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                />
            ) : (
                <span className='text-scogogray text-font11'>—</span>
            )}
        </div>
    );

    if (sp && fe && sp.agent.id === newLoggedUserData.user.id && fe.agent.id === newLoggedUserData.user.id) {
        return (
            <div className='mb-1'>
                <div className='flex items-center gap-2 mb-1'>
                    {/* <span className='text-scogogray text-font10'>{milestoneTitle}</span> */}
                    <AssingmentTypeLabel type={milestone.type} />
                </div>
                <AssignToYou label='SP/FE' />
            </div>
        );
    }

    if (sp && fe && sp.agent.id === fe.agent.id) {
        return (
            <div className='mb-1'>
                <div className='flex items-center gap-2 mb-1'>
                    {/* <span className='text-scogogray text-font10'>{milestoneTitle}</span> */}
                    <AssingmentTypeLabel type={milestone.type} />
                </div>
                <div className='flex items-center gap-2'>
                    <Label icon='badge' text='SP/FE :' />
                    {showInsuredIcon(ticket) && (
                        <IconToolTip title='FE is insured for this ticket'>
                            <span className='material-icons text-scogo2e text-font16'>gpp_good</span>
                        </IconToolTip>
                    )}
                    <PartnerDetailsPopUp userId={sp.agent.id} displayName={`${sp.agent.display_name}`} onHovertitle={`SP :  ${sp.agent.display_name}`} />
                </div>
            </div>
        );
    }

    return (
        <div className='mb-1'>
            <div className='flex items-center gap-2 mb-1'>
                {/* <span className='text-scogogray text-font10 whitespace-nowrap'>{milestoneTitle}</span> */}
                <AssingmentTypeLabel type={milestone.type} />
            </div>
            <div className='flex flex-col gap-1'>
                <SpRow />
                <FeRow />
            </div>
        </div>
    );
};

const GroupedMilestoneDisplay = ({ groupedItem, ticket, newLoggedUserData, isScogoId }) => {
    const groupedMilestones = groupedItem.milestones;
    const sp = groupedItem.sp;
    const fe = groupedItem.fe;

    const Label = ({ icon, text }) => (
        <span className='text-scogogray text-font11 inline-flex items-center gap-1 whitespace-nowrap'>
            <span className='material-icons text-font12'>{icon}</span>
            <span className='whitespace-nowrap'>{text}</span>
        </span>
    );

    const SpRow = () => (
        <div className='flex items-center gap-2'>
            <Label icon='manage_accounts' text='SP :' />
            {sp ? (
                <PartnerDetailsPopUp
                    userId={sp.agent.id}
                    displayName={`${sp.agent.display_name}`}
                    onHovertitle={`SP :  ${sp.agent.display_name}`}
                />
            ) : (
                <span className='text-scogogray text-font11'>—</span>
            )}
        </div>
    );

    const FeRow = () => (
        <div className='flex items-center gap-2'>
            <Label icon='engineering' text='FE :' />
            {showInsuredIcon(ticket) && (
                <IconToolTip title={'FE is insured for this ticket'}>
                    <span className='material-icons text-scogo2e text-font14 leading-none'>gpp_good</span>
                </IconToolTip>
            )}
            {fe ? (
                <PartnerDetailsPopUp
                    userId={fe.agent.id}
                    displayName={`${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                    onHovertitle={`FE :  ${fe.agent.display_name ? fe.agent.display_name : fe.agent.phone_number}`}
                />
            ) : (
                <span className='text-scogogray text-font11'>—</span>
            )}
        </div>
    );

    if (sp && fe && sp.agent.id === newLoggedUserData.user.id && fe.agent.id === newLoggedUserData.user.id) {
        return (
            <div className='mb-1'>
                <div className='flex items-center gap-2 mb-1'>
                    <div className='flex flex-wrap gap-1'>
                        {groupedMilestones.map((item, index) => (
                            <AssingmentTypeLabel key={index} type={item.milestone.type} showSlash={index !== groupedMilestones.length - 1} />
                        ))}
                    </div>
                </div>
                <AssignToYou label='SP/FE' />
            </div>
        );
    }

    if (sp && fe && sp.agent.id === fe.agent.id) {
        return (
            <div className='mb-1'>
                <div className='flex items-center gap-2 mb-1'>
                    <div className='flex flex-wrap gap-1'>
                        {groupedMilestones.map((item, index) => (
                            <AssingmentTypeLabel key={index} type={item.milestone.type} showSlash={index !== groupedMilestones.length - 1} />
                        ))}
                    </div>
                </div>
                <div className='flex items-center gap-2'>
                    <Label icon='badge' text='SP/FE :' />
                    {showInsuredIcon(ticket) && (
                        <IconToolTip title='FE is insured for this ticket'>
                            <span className='material-icons text-scogo2e text-font16'>gpp_good</span>
                        </IconToolTip>
                    )}
                    <PartnerDetailsPopUp userId={sp.agent.id} displayName={`${sp.agent.display_name}`} onHovertitle={`SP :  ${sp.agent.display_name}`} />
                </div>
            </div>
        );
    }

    return (
        <div className='mb-1'>
            <div className='flex items-center gap-2 mb-1'>
                <div className='flex flex-wrap gap-1'>
                    {groupedMilestones.map((item, index) => (
                        <AssingmentTypeLabel key={index} type={item.milestone.type} showSlash={index !== groupedMilestones.length - 1} />
                    ))}
                </div>
            </div>
            <div className='flex flex-col gap-1'>
                <SpRow />
                <FeRow />
            </div>
        </div>
    );
};

const ViewAllMilestones = ({ milestones, ticket, newLoggedUserData, isScogoId }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const itemsData = milestones.map((item) => {
        if (item.type === 'grouped') {
            return {
                id: item.groupKey,
                title: item.milestones.map(m => m.milestone.type || m.milestone.title).join(' / '),
                sp: item.sp,
                fe: item.fe,
                type: 'grouped',
                milestoneCount: item.milestones.length
            };
        } else {
            return {
                id: item.milestone.id,
                title: item.milestone.type || item.milestone.title,
                sp: item.sp,
                fe: item.fe,
                type: 'single'
            };
        }
    });

    const Chip = ({ label, value }) => (
        <span className='bg-tagbg scogoprimary text-font10 px-2 py-1 rounded-3px whitespace-nowrap max-w-[15rem] truncate'>{label}: {value}</span>
    );

    const handleOpen = (e) => {
        e?.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (e) => {
        e?.stopPropagation();
        setAnchorEl(null);
    };

    const renderValueChips = (item) => {
        const sp = item.sp;
        const fe = item.fe;
        if (sp && fe && sp.agent.id === newLoggedUserData.user.id && fe.agent.id === newLoggedUserData.user.id) {
            return (
                <span className='bg-tagbg text-scogobgsky text-font10 px-2 py-1 rounded-3px whitespace-nowrap'>Assign To You</span>
            );
        }
        if (sp && fe && sp.agent.id === fe.agent.id) {
            const name = sp?.agent?.display_name || fe?.agent?.display_name || fe?.agent?.phone_number || 'N/A';
            return (
                <Chip label='SP/FE' value={name} />
            );
        }
        return (
            <>
                {sp && <Chip label='SP' value={sp?.agent?.display_name || 'N/A'} />}
                {fe && <Chip label='FE' value={fe?.agent?.display_name || fe?.agent?.phone_number || 'N/A'} />}
            </>
        );
    };

    return (
        <div className='mt-1 inline-flex'>
            <button
                type='button'
                onClick={handleOpen}
                className='inline-flex items-center gap-1 text-font12 font-normal text-scogoorange hover:text-scogobgsky'
            >
                <span className='material-icons text-font12'>expand_more</span>
                +{milestones.length} more
            </button>
            <MUIMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    style: {
                        maxHeight: 360,
                        padding: '6px 10px',
                        minWidth: '22rem'
                    }
                }}
            >
                {itemsData.map((item) => (
                    <MUIMenuItem key={item.id} disableRipple onClick={(e) => e.stopPropagation()}>
                        <div className='flex items-center gap-2'>
                            <span className='text-scogoprimary text-font10 max-w-max font-medium'>
                                {item.title}
                                {item.type === 'grouped' && (
                                    <span className='text-scogogray ml-1'>({item.milestoneCount})</span>
                                )}
                            </span>
                            {renderValueChips(item)}
                        </div>
                    </MUIMenuItem>
                ))}
            </MUIMenu>
        </div>
    );
};

export const AssignButton = ({ ticket }) => {
    const dispatch = useDispatch();

    const onAssignClick = () => {
        let heading = (
            <span className='text-black'>Assign/ReAssign: <span className='text-scogobgsky'>{ticket.ticket_number}</span></span>
        );
        let modalComponent = <Assign ticket={ticket} />;
        let modalHeight = 'auto',
            modalWidth = '80rem';
        dispatch(openCustomModal({ modalComponent, heading, modalHeight, modalWidth }));
    };

    let label = 'Reassign';
    if (ticket.milestones && ticket.milestones.find((milestone) => milestone.milestone_status === MilestoneSubStatus.NEW)) {
        label = 'Assign';
    }

    return (
        <>
            <SimpleButton
                buttonIconComponent={<span className='material-icons text-font16'>manage_accounts</span>}
                btnClass='bg-white border flex items-center justify-center border-scogoprimary leading-6 cursor-pointer text-scogoprimary rounded-lg gap-1 font-medium cursor-pointer px-2 hover:bg-scogoprimary hover:text-white text-font11'
                textOrComponent={label}
                onClick={onAssignClick}
            />
        </>
    );
};

const AssignToYou = ({ label }) => {
    return (
        <div>
            <span className='text-scogogray w-10 text-font11'>{label}:</span>
            <span className='w-11/12 line-clamp-2 text-scogobgsky cursor-pointer text-left text-font11 hover:text-scogoorange'> Assign To You</span>
        </div>
    );
};

const AssignToScogo = () => {
    return (
        <div >
            <span className='text-scogogray w-10   text-font11'>SP :</span>
            <span className='w-11/12 line-clamp-2 text-scogobgsky cursor-pointer text-left text-font11 hover:text-scogoorange'> SCOGO</span>
        </div>
    );
};

const AssingmentTypeLabel = ({ type, showSlash = false }) => {
    if (!type) return <></>;
    return (
        <div className='my-1'>
            <span className={`bg-tagbg scogoprimary text-font10 px-2 py-1 rounded-3px max-w-full text-ellipsis truncate`}>{type}</span>
            {showSlash ? <span className='text-scogogray text-font11 font-bold'>&nbsp;/&nbsp;</span> : null}
        </div>
    );
};
